// @ts-nocheck
import { atom } from 'recoil';

export const companyDetailsState = atom<any>({
  key: "companyDetailsState",
});
